import { cx } from "class-variance-authority";
import { escapeRegExp } from "lodash";
interface HighlightedTextProps {
  text: string | null;
  keyword: string | null;
  highlighList?: string[];
  className?: string;
  highlightColor?: string;
}
function generateHighlightText(text: string, keywords: string[]) {
  const result: {
    content: string;
    isHighilighted: boolean;
  }[] = [];
  const escapedKeywords = keywords.map(escapeRegExp);
  const regex = new RegExp(escapedKeywords.join("|"), "gi");
  let match: RegExpExecArray | null;
  let lastIndex = 0;
  try {
    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        result.push({
          content: text.slice(lastIndex, match.index),
          isHighilighted: false
        });
      }
      result.push({
        content: match[0],
        isHighilighted: true
      });
      lastIndex = regex.lastIndex;
    }
    if (lastIndex < text.length) {
      result.push({
        isHighilighted: false,
        content: text.slice(lastIndex)
      });
    }
    return result;
  } catch {
    return null;
  }
}
export default function HighlightedText({
  text,
  keyword,
  highlighList = [],
  highlightColor = "bg-yellow-400",
  className
}: HighlightedTextProps) {
  if (!keyword || !text) {
    return text || "-";
  }
  const result = generateHighlightText(text, highlighList.length > 0 ? highlighList : [keyword]);
  if (!result) {
    return text || "-";
  }
  return <span className={className} data-sentry-component="HighlightedText" data-sentry-source-file="HighlightedText.tsx">
      {result.map((part, index) => {
      const {
        content,
        isHighilighted
      } = part;
      if (isHighilighted) {
        return <mark key={`${index}-${content}`} className={cx("inline bg-transparent p-0", highlightColor)}>
              {content}
            </mark>;
      }
      return content;
    })}
    </span>;
}